<template>

    <div class="preview_pencent">
        <div class="user_list_layout">

            <div v-for="(item, index) in rankUser" class="home_tab" :key="index">


                <div :class="tabIndex == index ? 'home_task_item_layout' : 'home_task_item_layout'" v-if="index > 2">

                    <div class="task_left_row_layout">
                        <div class="rank_index_num">{{ index + 1 }}</div>
                        <img v-if="item.avatar" :src="item.avatar" class="bee_task_logo">
                        <img v-else :src="default_avatar" class="bee_task_logo">
                    </div>

                    <div class="task_left_colunm_layout">
                        <div class="task_title"> {{ item.name }}</div>

                    </div>

                    <div class="task_claimed_send">
                        <div class="task_left_row_layout">
                            <div class="task_reward_txt">{{ setFixNumber(item.xp) }}</div>
                            <div class="bee_experience_logo" />
                        </div>
                    </div>


                </div>

                <div></div>


            </div>

            <div style="margin-bottom: 50px;"></div>
        </div>
        <div class="child">
            <div class="home_my_rank_item_layout" v-if="myself">

                <div class="task_left_row_layout">
                    <div class="rank_index_num">{{ myself.order }}</div>
                    <img v-if="myself.avatar" :src="myself.avatar" class="bee_task_logo">
                    <img v-else :src="default_avatar" class="bee_task_logo">
                </div>

                <div class="task_left_colunm_layout">
                    <div class="task_title"> {{ myself.name }}</div>

                </div>

                <div class="task_claimed_send">
                    <div class="task_left_row_layout">
                        <div class="task_reward_txt">{{ setFixNumber(myself.xp) }}</div>
                        <div class="bee_experience_logo" />
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import {
    baseUrl, api_base_url
} from "../../util/mock.js"
import icon_avatar from '../../assets/icon_pc_user_avcter.png';
export default {
    name: 'listView',
    props: {
        rankUser: [],
        myself: {},
    },
    data() {
        return {
            default_avatar: icon_avatar,
            // rankUser: [
            //     {
            //         "order": 0,
            //         "userId": "243160686@qq.com",
            //         "userName": "test",
            //         "xp": 62.00
            //     }
            // ],
            // myself: {
            //     "order": 0,
            //     "userId": "243160686@qq.com",
            //     "userName": "test",
            //     "xp": 61.00
            // },
        }
    },

    watch: {

    },

    methods: {
        async getAppTasks() {
            var url = api_base_url() + "/uni-task/app/tasks?userId=0";
            // console.log(url);
            const data = await fetch(url)
            const postContent = await data.json();
            this.rankUser = postContent.data;
            this.rankUser = this.rankUser.concat(this.rankUser);
            // console.log(postContent.data)
        },
        isDecimal(num) {
            return /^\d+\.\d+$/.test(num);
        },
        setFixNumber(num1) {
            if (this.isDecimal(num1)) {
                let m = Math.pow(10, 2); //放大10的2次方倍  100
                let value = (num1 * m) / m;  //(0.1*100 + 0.2*100）/100
                return value.toFixed(1)
            } else {
                return num1;
            }

        },
    },

    mounted() {
        // this.getAppTasks();

    },


}

</script>

<style scoped>
.preview_pencent {
    position: relative;
    width: -webkit-fill-available;
    width: -moz-available;
}

.user_list_layout {
    border: 1px #000;
    display: flex;
    flex-direction: column;
    overflow: overlay;
    height: 260px;
    border-radius: 20px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
}

@media (max-width:767.98px) {
    .user_list_layout {
        border: 1px #000;
        display: flex;
        flex-direction: column;
        overflow: overlay;
        height: 184px;
        border-radius: 20px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
}


.rank_index_num {
    color: #666;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.408px;
    margin-right: 8px;
    margin-left: 12px;
}

.home_task_item_layout {
    border: 1px #000;
    background: #FFF;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.14px;
    padding-bottom: 8px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
}

.bee_task_logo {
    width: 26px;
    height: 26px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-right: 6px;
    background: #ffc04d;
}

.bee_experience_logo {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-left: 2px;
    background-image: url("../../assets/icon_task_reward_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.task_left_colunm_layout {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    flex: 1;
}

.task_left_row_layout {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.task_title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.task_reward_txt {
    color: #FFB001;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.task_send {
    border-radius: 30px;
    background: #FFAE00;
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 4px;
    padding-bottom: 4px;
}

.task_claimed_send {
    color: #FFAE00;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 4px;
    padding-bottom: 4px;
}


.home_my_rank_item_layout {
    box-shadow: 0px -4px 8px 0px #3333331A;
    background: #FFF9EF;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.14px;
    margin-top: 8px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    padding-bottom: 8px;
    width: -webkit-fill-available;
    width: -moz-available;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;

}

.child {
    position: absolute;
    bottom: 0;
    width: -webkit-fill-available;
    width: -moz-available;
}
</style>